/**
 * Created by lihanying on 2017/6/29.
 */
import { GETCLUBCOMMODITYTYPE } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBCOMMODITYTYPE:
      return Object.assign({}, state, { clubCommodityType: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubCommodityType/reduce.js